import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';

const styles = () => ({
    dialog: {
        maxWidth: 760,
        minHeight: 700,
    },
    dialogFixed: {
        height: 700,
    },
});

const DefaultDialog = ({
    classes,
    open,
    onClose,
    children,
    autoHeight = false,
    dialogClass,
}) => {
    const paperScrollPaper = classNames(classes.dialog, {
        [classes.dialogFixed]: !autoHeight,
        [dialogClass]: dialogClass,
    });
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth={true}
            maxWidth={false}
            classes={{ paperScrollPaper }}
        >
            {children}
        </Dialog>
    );
};

export default withStyles(styles)(DefaultDialog);
